import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import { BasicRegulationFieldsFragmentDoc, BasicRegulatoryDocumentFieldsFragmentDoc, BasicRequirementFieldsFragmentDoc, BasicPogisFieldsFragmentDoc, BasicRegulatoryDocumentParaFieldsFragmentDoc } from '../../../fragments/basicFields.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetRegulationHoverContentQueryVariables = Types.Exact<{
  regulationId: Types.Scalars['ID'];
}>;


export type GetRegulationHoverContentQuery = { __typename?: 'Query', regulation?: { __typename?: 'Regulation', id: string, regulationNumber: string, name: string, summary: string, markets: Array<{ __typename?: 'Market', id: string, name: string }>, mainKeywords: Array<{ __typename?: 'Keyword', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, standardPlusPcmsClusters: Array<{ __typename?: 'StandardPlusPcmsCluster', id: string, name: string }>, contactPersons: Array<{ __typename?: 'User', name: string, id: string }> } | null };

export type GetRegulatoryDocumentHoverContentQueryVariables = Types.Exact<{
  regDocId: Types.Scalars['ID'];
}>;


export type GetRegulatoryDocumentHoverContentQuery = { __typename?: 'Query', regulatoryDocument?: { __typename?: 'RegulatoryDocument', id: string, name: string, status: Types.RegulatoryDocumentStatus, summary?: string | null, modelYear?: number | null, dateEffective?: any | null, dateExpiration?: any | null, dateNewRegistration?: any | null, dateNewTypes?: any | null, regulation?: { __typename?: 'Regulation', name: string, regulationNumber: string } | null, markets: Array<{ __typename?: 'Market', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, mainKeywords: Array<{ __typename?: 'Keyword', id: string, name: string }>, contactPersons: Array<{ __typename?: 'User', name: string, id: string }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, workflow: { __typename?: 'Workflow', status: Types.WorkflowStatus }, phaseOut: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }>, phaseIn: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> } | null };

export type GetRequirementHoverContentQueryVariables = Types.Exact<{
  requirementId: Types.Scalars['ID'];
}>;


export type GetRequirementHoverContentQuery = { __typename?: 'Query', requirement?: { __typename?: 'Requirement', id: string, name: string, status: Types.RequirementStatus, definition?: string | null, requirementId?: string | null, markets: Array<{ __typename?: 'Market', id: string, name: string }>, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, engineVariants: Array<{ __typename?: 'EngineVariant', id: string, name: string }>, gearboxVariants: Array<{ __typename?: 'GearboxVariant', id: string, name: string }>, bodyworkVariants: Array<{ __typename?: 'BodyworkVariant', id: string, name: string }>, activeTypeMarkets: Array<{ __typename?: 'ActiveTypeMarket', id: string, name: string }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string }>, systemLevels: Array<{ __typename?: 'SystemLevel', id: string, name: string }>, createdBy: { __typename?: 'User', name: string, id: string } } | null };

export type GetPogisHoverContentQueryVariables = Types.Exact<{
  pogisId: Types.Scalars['ID'];
}>;


export type GetPogisHoverContentQuery = { __typename?: 'Query', pogisDocument?: { __typename?: 'PogisDocument', associations?: Array<string> | null, createdAt?: any | null, docStatus: string, editor: string, id: string, keywords: Array<string>, linkVersion?: string | null, markets: Array<string>, modifiedAt?: any | null, pogisId: string, regulationStatus: string, relatedDocuments?: Array<string> | null, shortInfo: string, standards?: Array<string> | null, pogisAttachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, file: { __typename?: 'BlobRef', fileName: string, uri: any }, category?: { __typename?: 'AttachmentCategory', name: string } | null }> | null, dates: Array<{ __typename?: 'PogisDate', date: any, dateType: string }> } | null };


export const GetRegulationHoverContentDocument = gql`
    query getRegulationHoverContent($regulationId: ID!) {
  regulation(id: $regulationId) {
    ...BasicRegulationFields
  }
}
    ${BasicRegulationFieldsFragmentDoc}`;

/**
 * __useGetRegulationHoverContentQuery__
 *
 * To run a query within a React component, call `useGetRegulationHoverContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegulationHoverContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegulationHoverContentQuery({
 *   variables: {
 *      regulationId: // value for 'regulationId'
 *   },
 * });
 */
export function useGetRegulationHoverContentQuery(baseOptions: Apollo.QueryHookOptions<GetRegulationHoverContentQuery, GetRegulationHoverContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegulationHoverContentQuery, GetRegulationHoverContentQueryVariables>(GetRegulationHoverContentDocument, options);
      }
export function useGetRegulationHoverContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegulationHoverContentQuery, GetRegulationHoverContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegulationHoverContentQuery, GetRegulationHoverContentQueryVariables>(GetRegulationHoverContentDocument, options);
        }
export type GetRegulationHoverContentQueryHookResult = ReturnType<typeof useGetRegulationHoverContentQuery>;
export type GetRegulationHoverContentLazyQueryHookResult = ReturnType<typeof useGetRegulationHoverContentLazyQuery>;
export type GetRegulationHoverContentQueryResult = Apollo.QueryResult<GetRegulationHoverContentQuery, GetRegulationHoverContentQueryVariables>;
export const GetRegulatoryDocumentHoverContentDocument = gql`
    query getRegulatoryDocumentHoverContent($regDocId: ID!) {
  regulatoryDocument(id: $regDocId) {
    ...BasicRegulatoryDocumentFields
  }
}
    ${BasicRegulatoryDocumentFieldsFragmentDoc}`;

/**
 * __useGetRegulatoryDocumentHoverContentQuery__
 *
 * To run a query within a React component, call `useGetRegulatoryDocumentHoverContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegulatoryDocumentHoverContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegulatoryDocumentHoverContentQuery({
 *   variables: {
 *      regDocId: // value for 'regDocId'
 *   },
 * });
 */
export function useGetRegulatoryDocumentHoverContentQuery(baseOptions: Apollo.QueryHookOptions<GetRegulatoryDocumentHoverContentQuery, GetRegulatoryDocumentHoverContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegulatoryDocumentHoverContentQuery, GetRegulatoryDocumentHoverContentQueryVariables>(GetRegulatoryDocumentHoverContentDocument, options);
      }
export function useGetRegulatoryDocumentHoverContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegulatoryDocumentHoverContentQuery, GetRegulatoryDocumentHoverContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegulatoryDocumentHoverContentQuery, GetRegulatoryDocumentHoverContentQueryVariables>(GetRegulatoryDocumentHoverContentDocument, options);
        }
export type GetRegulatoryDocumentHoverContentQueryHookResult = ReturnType<typeof useGetRegulatoryDocumentHoverContentQuery>;
export type GetRegulatoryDocumentHoverContentLazyQueryHookResult = ReturnType<typeof useGetRegulatoryDocumentHoverContentLazyQuery>;
export type GetRegulatoryDocumentHoverContentQueryResult = Apollo.QueryResult<GetRegulatoryDocumentHoverContentQuery, GetRegulatoryDocumentHoverContentQueryVariables>;
export const GetRequirementHoverContentDocument = gql`
    query getRequirementHoverContent($requirementId: ID!) {
  requirement(id: $requirementId) {
    ...BasicRequirementFields
  }
}
    ${BasicRequirementFieldsFragmentDoc}`;

/**
 * __useGetRequirementHoverContentQuery__
 *
 * To run a query within a React component, call `useGetRequirementHoverContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequirementHoverContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequirementHoverContentQuery({
 *   variables: {
 *      requirementId: // value for 'requirementId'
 *   },
 * });
 */
export function useGetRequirementHoverContentQuery(baseOptions: Apollo.QueryHookOptions<GetRequirementHoverContentQuery, GetRequirementHoverContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequirementHoverContentQuery, GetRequirementHoverContentQueryVariables>(GetRequirementHoverContentDocument, options);
      }
export function useGetRequirementHoverContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequirementHoverContentQuery, GetRequirementHoverContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequirementHoverContentQuery, GetRequirementHoverContentQueryVariables>(GetRequirementHoverContentDocument, options);
        }
export type GetRequirementHoverContentQueryHookResult = ReturnType<typeof useGetRequirementHoverContentQuery>;
export type GetRequirementHoverContentLazyQueryHookResult = ReturnType<typeof useGetRequirementHoverContentLazyQuery>;
export type GetRequirementHoverContentQueryResult = Apollo.QueryResult<GetRequirementHoverContentQuery, GetRequirementHoverContentQueryVariables>;
export const GetPogisHoverContentDocument = gql`
    query getPogisHoverContent($pogisId: ID!) {
  pogisDocument(id: $pogisId) {
    ...BasicPogisFields
  }
}
    ${BasicPogisFieldsFragmentDoc}`;

/**
 * __useGetPogisHoverContentQuery__
 *
 * To run a query within a React component, call `useGetPogisHoverContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPogisHoverContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPogisHoverContentQuery({
 *   variables: {
 *      pogisId: // value for 'pogisId'
 *   },
 * });
 */
export function useGetPogisHoverContentQuery(baseOptions: Apollo.QueryHookOptions<GetPogisHoverContentQuery, GetPogisHoverContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPogisHoverContentQuery, GetPogisHoverContentQueryVariables>(GetPogisHoverContentDocument, options);
      }
export function useGetPogisHoverContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPogisHoverContentQuery, GetPogisHoverContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPogisHoverContentQuery, GetPogisHoverContentQueryVariables>(GetPogisHoverContentDocument, options);
        }
export type GetPogisHoverContentQueryHookResult = ReturnType<typeof useGetPogisHoverContentQuery>;
export type GetPogisHoverContentLazyQueryHookResult = ReturnType<typeof useGetPogisHoverContentLazyQuery>;
export type GetPogisHoverContentQueryResult = Apollo.QueryResult<GetPogisHoverContentQuery, GetPogisHoverContentQueryVariables>;